import produce, { Draft } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { EmarketingTemplateState, initialState } from './model';

const emarketingTemplate = produce((draft: Draft<EmarketingTemplateState>, action: ActionType<typeof actions>) => {
  switch (action.type) {
    case getType(actions.getList.request): {
      draft.list.loading = true;
      return draft;
    }
    case getType(actions.getList.success): {
      draft.list.loading = true;
      draft.list.response = action.payload;
      return draft;
    }
    case getType(actions.getList.failure): {
      draft.list.loading = false;
      draft.list.errors = action.payload;
      return draft;
    }
    case getType(actions.getDetails.request): {
      draft.details.loading = true;
      draft.details.response = undefined;
      draft.details.errors = undefined;
      return draft;
    }
    case getType(actions.getDetails.success): {
      draft.details.loading = true;
      draft.details.response = action.payload;
      return draft;
    }
    case getType(actions.getDetails.failure): {
      draft.details.loading = false;
      draft.details.errors = action.payload;
      return draft;
    }
    case getType(actions.createData.request): {
      draft.details.loading = true;
      return draft;
    }
    case getType(actions.createData.success): {
      draft.create.loading = false;
      draft.create.response = action.payload;
      return draft;
    }
    case getType(actions.createData.failure): {
      draft.create.loading = false;
      draft.create.errors = action.payload;
      return draft;
    }
    case getType(actions.updateData.request): {
      draft.update.loading = true;
      return draft;
    }
    case getType(actions.updateData.success): {
      draft.update.loading = false;
      draft.update.response = action.payload;
      return draft;
    }
    case getType(actions.updateData.failure): {
      draft.update.loading = false;
      draft.update.errors = action.payload;
      return draft;
    }
    case getType(actions.deleteData.request): {
      draft.delete.loading = true;
      return draft;
    }
    case getType(actions.deleteData.success): {
      draft.delete.loading = false;
      draft.delete.response = action.payload;
      return draft;
    }
    case getType(actions.deleteData.failure): {
      draft.delete.loading = false;
      draft.delete.errors = action.payload;
      return draft;
    }
    case getType(actions.bulkDatas.request): {
      draft.bulk.loading = true;
      return draft;
    }
    case getType(actions.bulkDatas.success): {
      draft.bulk.loading = false;
      draft.bulk.response = action.payload;
      return draft;
    }
    case getType(actions.bulkDatas.failure): {
      draft.bulk.loading = false;
      draft.bulk.errors = action.payload;
      return draft;
    }
    case getType(actions.clearData): {
      if (action.payload) {
        draft[action.payload] = {};
      } else {
        draft = initialState;
      }
      return draft;
    }
    default: {
      return draft;
    }
  }
}, initialState);

export default emarketingTemplate;
